import { Check, CheckCheck, CircleCheck, Minus, type LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

type CheckmarkProps = LucideProps & { variant?: 'check' | 'circle' | 'double' | 'mixed' };

/** A single, theme-inheriting checkmark, using the installed Lucide icon set. */
export function Checkmark({ variant = 'check', className, ...props }: CheckmarkProps) {
  const Icon = { check: Check, circle: CircleCheck, double: CheckCheck, mixed: Minus }[variant];
  return <Icon data-slot="checkmark" aria-hidden="true" strokeWidth={2} className={cn('shrink-0', className)} {...props} />;
}

export function CheckmarkCircle(props: LucideProps) { return <Checkmark variant="circle" {...props} />; }
export function CheckmarkDouble(props: LucideProps) { return <Checkmark variant="double" {...props} />; }

/** Decorative selection mark inside an already-interactive card or button. */
export function SelectionMark({ checked, className, ...props }: ComponentProps<'span'> & { checked: boolean | 'indeterminate' }) {
  return <span aria-hidden="true" data-state={checked === 'indeterminate' ? 'indeterminate' : checked ? 'checked' : 'unchecked'} className={cn('themed-checkbox pointer-events-none inline-grid place-items-center', className)} {...props}>
    {checked && <Checkmark variant={checked === 'indeterminate' ? 'mixed' : 'check'} className="size-3.5" />}
  </span>;
}
